import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'
import { googleSheetApi } from 'shared/api/requests/integrations/googleSheets'
import { createAsyncAction } from 'shared/lib/redux'
import errorTrackingService from 'utils/services/errorTrackingService'

export const fetchSpreadsheets = createAsyncAction(
  'integration/googleSheets/getSpreadsheets',
  async () => {
    const response = await googleSheetApi.getSpreadsheets()
    return response.data
  },
  {
    onBusinessError: (error) => {
      errorTrackingService.trackError(error, { fingerprint: 'fetch-spreadsheets' })
    },
  },
)

export const fetchWorksheets = createAsyncAction(
  'integration/googleSheets/getWorksheets',
  async (spreadsheet_id) => {
    const response = await googleSheetApi.getWorksheets({ query: { spreadsheet_id } })
    return response.data
  },
  {
    onBusinessError: (error) => {
      errorTrackingService.trackError(error, { fingerprint: 'fetch-worksheets' })
    },
  },
)

export const fetchColumnHeaders = createAsyncAction(
  'integration/googleSheets/getColumnHeaders',
  async ({ spreadsheetId, sheetTitle }) => {
    const response = await googleSheetApi.getColumnHeaders({
      query: { spreadsheet_id: spreadsheetId, sheet_title: sheetTitle },
    })
    return response.data
  },
  {
    onBusinessError: (error) => {
      errorTrackingService.trackError(error, { fingerprint: 'fetch-column-headers' })
    },
  },
)

export const setCurrentSpreadSheetId = (spreadsheet) => ({
  type: atypes.GOOGLE_SHEETS_SET_CURRENT_SHEET,
  spreadsheet,
})

export const setCurrentWorkSheetTitle = (sheet) => ({
  type: atypes.GOOGLE_SHEETS_SET_CURRENT_WORK_SHEET,
  sheet,
})

export const setMapping = (mapping) => ({
  type: atypes.GOOGLE_SHEETS_SET_MAPPING,
  mapping,
})

export const setBinding = (binding) => ({
  type: atypes.GOOGLE_SHEETS_SET_BINDING,
  binding,
})

export const updateBinding = (index, changes) => ({
  type: atypes.GOOGLE_SHEETS_UPDATE_BINDING,
  payload: { index, changes },
})

export const deleteBinding = (index) => ({
  type: atypes.GOOGLE_SHEETS_DELETE_BINDING,
  index,
})

export const updateMapping = (index, changes) => ({
  type: atypes.GOOGLE_SHEETS_UPDATE_MAPPING,
  payload: { index, changes },
})

export const deleteMapping = (index) => ({
  type: atypes.GOOGLE_SHEETS_DELETE_MAPPING,
  index,
})

export const setCurrentSheetLink = (link) => ({
  type: atypes.GOOGLE_SHEETS_SET_LINK,
  link,
})

export const setCurrentColumn = (nameKey) => ({
  type: atypes.GOOGLE_SHEETS_SET_COLUMN,
  nameKey,
})

export const setCurrentLookupValue = (payload) => ({
  type: atypes.GOOGLE_SHEETS_SET_LOOKUP_VALUE,
  payload,
})

export const resetSheet = () => {
  return (dispatch, getState) => {
    const currentSheet = getState().integrations.google_sheets.spreadsheet

    dispatch(setCurrentSheetLink(''))
    dispatch(setCurrentWorkSheetTitle(null))
    dispatch(fetchWorksheets(currentSheet))
  }
}

export const resetSpreadSheet = () => {
  return (dispatch, getState) => {
    dispatch(setCurrentSheetLink(''))
    dispatch(setCurrentSpreadSheetId(null))
    dispatch(fetchSpreadsheets())
  }
}
